import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { SectionCus } from './SectionCus'

export const OurPhilosophy = () => {
  const { t } = useTranslation()

  return (
    <div className="bg-gradient-to-r from-iceBlue to-paleBlue">
      <SectionCus>
        <div className="py-8 px-4 md:py-20 md:px-10">
          <div className="flex flex-wrap gap-x-6 md:gap-x-0 justify-center lg:justify-between md:flex-wrap md:flex-row md:justify-around gap-y-4 lg:gap-y-0">
            <img src="img/sponsors/PPA_Logo.png" alt="Pro Pickleball Association" className="lg:h-16 h-24" />
            <img src="img/sponsors/Pickles_Logo.png" alt="Pickles" className="lg:h-16 h-24" />
            <img src="img/sponsors/MLP_Logo.png" alt="Major League Pickleball" className="lg:h-16 h-24" />
            <img src="img/sponsors/cirkul_logo.png" alt="Cirkul" className="lg:h-16 h-24" />
            <img src="img/sponsors/The_Picklr_Logo.png" alt="The Picklr" className="lg:h-16 h-24" />
            <img src="img/sponsors/Gamma_logo.png" alt="Gamma Pickleball" className="lg:h-16 h-24" />
          </div>
          <div className="flex flex-wrap gap-x-6 md:gap-x-0 justify-center lg:justify-between md:flex-wrap md:flex-row md:justify-around gap-y-4 lg:gap-y-0">
            <img src="img/sponsors/oofos_logo.png" alt="Oofos" className="lg:h-16 h-24" />
            <img src="img/sponsors/Legacy_Pickleball@3x.png" alt="Legacy_Pickleball" className="lg:h-16 h-24" />
            <img src="img/sponsors/NYC_Pickleball@3x.png" alt="NYC_Pickleball" className="lg:h-16 h-24" />
            <img src="img/sponsors/michelob_logo.png" alt="michelob ULTRA" className="lg:h-16 h-24" />
            <img
              src="img/sponsors/Missouri Pickleball Club@3x.png"
              alt="Missouri Pickleball Club"
              className="lg:h-16 h-24"
            />
            <Link to="https://www.totalpickleball.com/?from=dupr" className="flex items-center justify-center">
              <img
                src="img/sponsors/logo_totalpickleball.svg"
                alt="Total Pickleball"
                className="lg:h-16 h-24 scale-[1.2]"
              />
            </Link>
          </div>
        </div>

        <div className="py-8 px-4 md:py-20 md:px-10 flex flex-col lg:flex-row">
          <div className="w-full lg:w-1/2 flex items-center">
            <img src="img/showcase/Showcase.png" alt="showcase" className="object-contain" />
          </div>
          <div className="w-full mt-10 lg:mt-0 lg:w-1/2 pl-0 md:pl-14 flex gap-y-5 flex-col justify-center">
            <p className="text-xl font-semibold text-azul">{t('home.ourPhilosophy')}</p>

            <p className="text-5xl leading-tight font-semibold text-darkNavy">
              {t('home.innovateGame')}
              <br /> {t('home.unifySport')}
            </p>

            <p className="text-base leading-normal font-semibold text-darkNavy">{t('home.theMostAccurateGlobal')}</p>

            <div className="flex">
              <div className="w-10 h-10 flex-none">
                <img src="img/chart.png" alt="chart" />
              </div>
              <div className="ml-9">
                <p className="text-lg font-semibold text-darkNavy mb-2">{t('home.optimizedAccuracy')}</p>
                <p className="text-base text-darkNavy">{t('home.yourDUPRRating')}:</p>
                <ol className="ml-4 mt-2 list-decimal list-inside">
                  <li>
                    <span className="font-bold">{t('home.marginVictory')}</span> {'home.pointsWon'}
                  </li>
                  <li>
                    <span className="font-bold">{'home.typeResult'}</span> {t('home.recreationalEtc')}
                  </li>
                  <li>
                    <span className="font-bold">{t('home.outcome')}</span> {t('home.winLoss')}
                  </li>
                </ol>
              </div>
            </div>

            <div className="flex">
              <div className="w-10 h-10 flex-none">
                <img src="img/trusted.png" alt="chart" />
              </div>
              <div className="ml-9">
                <p className="text-lg font-semibold text-darkNavy mb-2">{t('home.builtPickleball')}</p>
                <p className="text-base text-darkNavy">{t('home.builtPickleballDesc')}</p>
              </div>
            </div>
          </div>
        </div>
      </SectionCus>
    </div>
  )
}
